import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'eg-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './eg-button.component.html',
  styleUrl: './eg-button.component.scss',
})
export class EgButtonComponent {
  buttonClass = 'btn'; // primary class

  @Input() label = ''; // label name
  @Input() type!: string; // button Type
  @Input() className!: string; // bootstrap class
  @Input() style!: string; // style of an element
  @Input() iconName!: string; // icon name e.g. fa-fa pencil
  @Input() isDisabled: boolean = false;
  @Input() id = ''; // id
  @Input() iconClass = '';

  @Output() onClick = new EventEmitter<any>(); // button click event

  onClickbutton(event: any) {
    this.onClick.emit(event);
  }
}
